export default __webpack_public_path__ + "5367103510b27b78482794590e1ce3b0.ttf";